export enum VolumeType {
    main = 'main',
    shared = 'shared',
}
